export interface MembersDirectoryPreferences {
  splitView: boolean;
  extendedPreview: boolean;
}

const DEFAULT_PREFERENCES: MembersDirectoryPreferences = {
  splitView: true,
  extendedPreview: false,
};

const storageKeyFor = (churchId?: string) =>
  churchId ? `trinity.members.directory-preferences:${churchId}` : 'trinity.members.directory-preferences';

export const loadMembersDirectoryPreferences = (churchId?: string): MembersDirectoryPreferences => {
  if (typeof window === 'undefined') return DEFAULT_PREFERENCES;
  try {
    const raw = window.localStorage.getItem(storageKeyFor(churchId));
    if (!raw) return DEFAULT_PREFERENCES;
    const parsed = JSON.parse(raw) as Partial<MembersDirectoryPreferences>;
    return {
      splitView: parsed.splitView !== false,
      extendedPreview: parsed.extendedPreview === true,
    };
  } catch {
    return DEFAULT_PREFERENCES;
  }
};

export const persistMembersDirectoryPreferences = (
  churchId: string | undefined,
  preferences: MembersDirectoryPreferences,
) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKeyFor(churchId), JSON.stringify(preferences));
  } catch {
    // Ignore storage failures.
  }
};
